module.exports = __webpack_public_path__ + "img/left-arrow.5c2a9944.svg";